export const ComponentTypes = {
  BRIDGE_FUNDING:
    "Commitments.commitmentComponents.create.form.fields.componentType.bridgeFunding",
  DC: "Commitments.commitmentComponents.create.form.fields.componentType.dc",
  GRAD_STUDENT_SUPPORT:
    "Commitments.commitmentComponents.create.form.fields.componentType.gradStudentSupport",
  HOUSING:
    "Commitments.commitmentComponents.create.form.fields.componentType.housingOptionValue",
  MCD_BACKSTOP:
    "Commitments.commitmentComponents.create.form.fields.componentType.mcdBackstop",
  MOCK_ENDOWMENT:
    "Commitments.commitmentComponents.create.form.fields.componentType.mockEndowment",
  RENOVATION:
    "Commitments.commitmentComponents.create.form.fields.componentType.renovation",
  SEED_GRANTS:
    "Commitments.commitmentComponents.create.form.fields.componentType.seedGrants",
  SUBSIDY:
    "Commitments.commitmentComponents.create.form.fields.componentType.subsidy",
  REQUEST:
    "Commitments.commitmentComponents.create.form.fields.componentType.request",
  DEAN_COMMITMENT: "Budgeting.mainView.list.tableColumns.deansCommitments",
};

export const ComponentDispositionTypes = {
  APPROVED: "Commitments.commitmentComponents.dispositionTypes.approved",
  DEFER: "Commitments.commitmentComponents.dispositionTypes.defer",
  NOT_APPROVED: "Commitments.commitmentComponents.dispositionTypes.notApproved",
  REQUEST: "Commitments.commitmentComponents.dispositionTypes.requested",
};

export const DocumentTypes = {
  OFFER_LETTER:
    "Commitments.commitmentDocuments.create.form.fields.documentType.offerLetterOptionValue",
  EMAIL:
    "Commitments.commitmentDocuments.create.form.fields.documentType.emailOptionValue",
  RECRUITMENT:
    "Commitments.commitmentDocuments.create.form.fields.documentType.recruitmentOptionValue",
  OTHER:
    "Commitments.commitmentDocuments.create.form.fields.documentType.otherOptionValue",
};

export const CommitmentTypes = {
  REGULAR: "Commitments.create.form.fields.commitmentType.regularOptionValue",
  PLACEHOLDER:
    "Commitments.create.form.fields.commitmentType.placeholderOptionValue",
  MEMO: "Commitments.create.form.fields.commitmentType.memoOptionValue",
  REQUEST: "Commitments.create.form.fields.commitmentType.requestOptionValue",
  DEFERRED: "Commitments.create.form.fields.commitmentType.deferredOptionValue",
};

export const ExpensesPosted = {
  POSTED:
    "UploadedExpenses.filterPanelItems.options.postedDropdownValues.posted",
  UNPOSTED:
    "UploadedExpenses.filterPanelItems.options.postedDropdownValues.unPosted",
};

export const ExpensesConditionType = {
  ERROR:
    "UploadedExpenses.filterPanelItems.options.conditionTypeDropdownValues.error",
  WARNING:
    "UploadedExpenses.filterPanelItems.options.conditionTypeDropdownValues.warning",
  REDISTRIBUTED:
    "UploadedExpenses.filterPanelItems.options.conditionTypeDropdownValues.redistributed",
};

export const ExpensesNotification = {
  UNRESOLVED:
    "UploadedExpenses.filterPanelItems.options.notificationDropdownValues.unprocessed",
  INPROCESS:
    "UploadedExpenses.filterPanelItems.options.notificationDropdownValues.inProcess",
  RESOLVED:
    "UploadedExpenses.filterPanelItems.options.notificationDropdownValues.resolved",
};

export const TransferTypes = {
  TRANSFER_IN: "UploadedTransfers.mainView.list.transferTypeValues.transferIn",
  TRANSFER_OUT:
    "UploadedTransfers.mainView.list.transferTypeValues.transferOut",
  RECEIPT: "UploadedTransfers.mainView.list.transferTypeValues.receipt",
};

export const TransactionTypes = {
  EXPENSE:
    "Commitments.financialHistory.financialTransaction.create.transactionTypes.expenses",
  TRANSFER:
    "Commitments.financialHistory.financialTransaction.create.transactionTypes.transfers",
};

export const LinkToPTARequestForm =
  "https://docs.google.com/forms/d/e/1FAIpQLSd1YMKRhb-K50v4zyqM9f7SMq7h6oHb9AROyl4pNZo_aDrX2g/viewform";

/*
  For reference, this file lives in the "Application Service > MedCommit" folder here:
  https://drive.google.com/drive/u/1/folders/1Jj-RX1Zd-Wu4bVOSdo7Wy4AaXEwrhUFX
*/
export const LinkToFacultyNewHireTemplate = {
  downloadUrl:
    "https://docs.google.com/spreadsheets/d/1c-SJtch2xV8wFmxngNTn2iOieHJNby2ldoE9aKxxeAg/export?format=xlsx",
  filename: "Faculty New Hire Commitments.xlsx",
};

export const MovedStatus = {
  MOVED: "MOVED",
  ORIGINAL: "ORIGINAL",
};

/**
 * Browser Storage API names
 */
export const STORAGE_TYPE = {
  LOCAL: "localStorage",
  SESSION: "sessionStorage",
};

/**
 * Key names for specific Session/LocalStorage values
 */
export const STORAGE_NAMES = {
  COM_BUDGETING_DASHBOARD_FILTERS: "COM_BUDGETING_DASHBOARD_FILTERS",
};
